"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTermsPanel = void 0;
var termsandconditions_cms_1 = require("../components/cards/TermsAndConditionsCard/termsandconditions.cms");
var orderTermsPanelCms_cms_1 = require("../components/panels/OrderTermsPanel/orderTermsPanelCms.cms");
var OrderTermsPanel = /** @class */ (function () {
    function OrderTermsPanel() {
        this.termsAndConditions = new termsandconditions_cms_1.TermsAndConditionsCms();
        this.panelContent = new orderTermsPanelCms_cms_1.OrderTermsPanelCms();
    }
    return OrderTermsPanel;
}());
exports.OrderTermsPanel = OrderTermsPanel;
//# sourceMappingURL=OrderTermsPanel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/cms/OrderTermsPanel.cms.js
// module id = 2022
// module chunks = 8